var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLawIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.25 -5.217)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.25 6.217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.892,57.2H21.958a2.431,2.431,0,0,1-2.427-2.427v-17.2a.607.607,0,1,1,1.214,0v17.2a1.215,1.215,0,0,0,1.214,1.214h4.934a.607.607,0,1,1,0,1.214Z",
    transform: "translate(-14.373 -25.025)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.775,27.3a.607.607,0,0,1-.607-.607V18.023L42.3,12.151H30.248a.607.607,0,1,1,0-1.214h12.3a.608.608,0,0,1,.429.178L49.2,17.341a.607.607,0,0,1,.178.429v8.921a.607.607,0,0,1-.607.607Z",
    transform: "translate(-20.556 -9.104)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.92,87.151h-7.2a.607.607,0,0,1,0-1.214h7.2a.607.607,0,1,1,0,1.214Z",
    transform: "translate(-35.521 -54.974)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.145,18.378H63.739a2.431,2.431,0,0,1-2.427-2.427V11.544a.607.607,0,0,1,1.214,0V15.95a1.215,1.215,0,0,0,1.214,1.214h4.406a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-39.926 -9.104)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125,42.627H28.294a.607.607,0,0,1-.607-.607V39.189a.607.607,0,0,1,.607-.607h2.831a.607.607,0,0,1,.607.607V42.02A.607.607,0,0,1,31.125,42.627ZM28.9,41.413h1.617V39.8H28.9Z",
    transform: "translate(-19.361 -26.012)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.806,41.3h-6.2a.607.607,0,1,1,0-1.214h6.2a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-27.503 -26.934)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.745,45.581H41.607a.607.607,0,0,1,0-1.214h3.138a.607.607,0,1,1,0,1.214Z",
    transform: "translate(-27.504 -29.55)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125,57.029H28.294a.607.607,0,0,1-.607-.607V53.591a.607.607,0,0,1,.607-.607h2.831a.607.607,0,0,1,.607.607v2.831A.607.607,0,0,1,31.125,57.029ZM28.9,55.815h1.617V54.2H28.9Z",
    transform: "translate(-19.361 -34.82)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.806,55.7h-6.2a.607.607,0,1,1,0-1.214h6.2a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-27.503 -35.74)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.745,59.98H41.607a.607.607,0,0,1,0-1.214h3.138a.607.607,0,1,1,0,1.214Z",
    transform: "translate(-27.504 -38.356)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.125,71.428H28.294a.607.607,0,0,1-.607-.607V67.99a.607.607,0,0,1,.607-.607h2.831a.607.607,0,0,1,.607.607v2.831A.607.607,0,0,1,31.125,71.428ZM28.9,70.214h1.617V68.6H28.9Z",
    transform: "translate(-19.361 -43.626)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.255,70.1H41.607a.607.607,0,1,1,0-1.214h1.648a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-27.504 -44.546)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.375,74.382h-.765a.607.607,0,1,1,0-1.214h.765a.607.607,0,0,1,0,1.214Z",
    transform: "translate(-27.506 -47.165)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.015,19.378a.606.606,0,0,1-.331-.1L9.157,17.635A6.352,6.352,0,0,1,6.25,12.276V9.236A.606.606,0,0,1,6.6,8.686l5.158-2.412a.61.61,0,0,1,.514,0L17.43,8.686a.605.605,0,0,1,.349.549v3.04a6.353,6.353,0,0,1-2.908,5.36l-2.526,1.643a.606.606,0,0,1-.331.1ZM7.464,9.623v2.654a5.145,5.145,0,0,0,2.353,4.341l2.2,1.429,2.2-1.429a5.143,5.143,0,0,0,2.355-4.341V9.623L12.015,7.5Z",
    transform: "translate(-6.25 -6.217)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.315,20.787a.607.607,0,0,1-.429-.178L14.275,19a.607.607,0,0,1,.859-.859l1.18,1.18L18.5,17.138a.607.607,0,0,1,.859.859l-2.613,2.613a.6.6,0,0,1-.429.178Z",
    transform: "translate(-11.05 -12.788)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.356,88.974H42.149a.606.606,0,0,1-.5-.945l1.227-1.821a.608.608,0,0,1,.5-.267H54.235a.608.608,0,0,1,.517.288l1.123,1.821a.608.608,0,0,1-.517.925ZM43.292,87.76H54.271l-.373-.607H43.7Z",
    transform: "translate(-27.835 -54.977)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.039,67.139h-.055a2.077,2.077,0,0,1-1.5-.689l-5.776-6.419-.727.727.256.256a.606.606,0,0,1,0,.859l-1.347,1.341a.608.608,0,0,1-.857,0L50.408,58.6a.608.608,0,0,1,0-.859l1.347-1.347a.608.608,0,0,1,.859,0l.256.256,3.763-3.767-.255-.256a.606.606,0,0,1,0-.856l1.347-1.347a.608.608,0,0,1,.859,0L63.2,55.044a.606.606,0,0,1,0,.857l-1.341,1.347a.606.606,0,0,1-.859,0l-.256-.256-.727.727,6.419,5.774a2.094,2.094,0,0,1-1.4,3.649Zm1.05-1.042H66.1Zm-8.357-7.555h.015a.606.606,0,0,1,.435.2l6.2,6.894a.874.874,0,0,0,.63.288.838.838,0,0,0,.645-.258.88.88,0,0,0-.032-1.276l-6.892-6.2a.607.607,0,0,1-.023-.88L60.321,55.7a.608.608,0,0,1,.859,0l.255.255.485-.487L58.159,51.7l-.492.492.255.256a.606.606,0,0,1,0,.856L53.3,57.929a.608.608,0,0,1-.859,0l-.256-.256-.489.489,3.766,3.761.489-.485-.255-.255a.608.608,0,0,1,0-.859l1.608-1.608a.607.607,0,0,1,.429-.178Z",
    transform: "translate(-33.149 -33.143)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.323,71.837a.607.607,0,0,1-.429-.178L55.638,68.4a.607.607,0,0,1,.859-.859L59.753,70.8a.607.607,0,0,1-.429,1.036Z",
    transform: "translate(-36.348 -43.617)",
    fill: "#445862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.229,59.935a.607.607,0,0,1-.429-.178L67.544,56.5a.607.607,0,0,1,.859-.859L71.659,58.9a.607.607,0,0,1-.429,1.036Z",
    transform: "translate(-43.629 -36.338)",
    fill: "#445862"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLawIcon);
export default __webpack_public_path__ + "static/media/law-icon.964b55d7dabca02bc0c1358af2b8ae62.svg";
export { ForwardRef as ReactComponent };